"use client";
import { Typography } from "@components/typography";
import CheckIcon from "@icons/check";
import clsx from "clsx";
import { DropdownMenu } from "radix-ui";
import React from "react";
import type { MenuRadioItemProps } from "./interface";
import css from "./styles.module.css";

/** @ignore */
export const MenuRadioItem = React.forwardRef<HTMLDivElement, MenuRadioItemProps>(
  ({ label, StartIcon, value, trailingSlot, disabled, onSelect, supportingText, ...props }, ref) => {
    const classNames = clsx(css.root, disabled && css.disabled);

    return (
      <DropdownMenu.RadioItem
        {...props}
        disabled={disabled}
        value={value}
        data-quipu="MenuRadioItem"
        className={classNames}
        ref={ref}
        onSelect={(e) => {
          e.preventDefault();
          onSelect?.(e);
        }}
      >
        {!disabled && (
          <DropdownMenu.ItemIndicator className={css.checkIcon}>
            <CheckIcon />
          </DropdownMenu.ItemIndicator>
        )}
        {StartIcon && (
          <span className={css.startIcon}>
            <StartIcon />
          </span>
        )}
        <span className={css.label}>
          <span>{label}</span>
          {supportingText && (
            <Typography component="span" variant="labelSmSubtle" color="subtle">
              {supportingText}
            </Typography>
          )}
        </span>
        {trailingSlot && <span className={css.trailingSlot}>{trailingSlot}</span>}
      </DropdownMenu.RadioItem>
    );
  },
);

MenuRadioItem.displayName = "MenuRadioItem";
